import React from "react";
import { motion } from "framer-motion";
import pp from "../../assets/SkillsImage/PP.jpg";

function ProfileImage() {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.4, duration: 0.5 }}
      className="max-w-md mx-auto"
    >
      <motion.img
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.7, duration: 0.5 }}
        className="rounded-full h-48 w-48 mx-auto"
        src={pp}
        alt=""
      />
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 2.0, duration: 0.5 }}
        className="pt-6 text-center space-y-4"
      >
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 2.3, duration: 0.5 }}
          className="text-lg font-medium text-slate-50"
        >
          Sertaç Gültekin
        </motion.p>
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 2.6, duration: 0.5 }}
          className="text-sm text-gray-500"
        >
          Software Developer
        </motion.p>
      </motion.div>
    </motion.div>
  );
}

export default ProfileImage;
